<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else class="row justify-content-center">
            <div v-if="!loading && financial_information" class="col-md-6 mb-5">
                <alert-success :form="form" :class="'shadow-sm'" message="Your changes have been saved!"></alert-success>
				<approval-alert-component :hasPendingApproval="financial_information.hasPendingApproval"></approval-alert-component>

                <h3 class="tx-color-01 mg-b-10">Financial Information</h3>
                <p class="tx-color-03 mg-b-10">
                    Due to legal requiremenets relating to sanctions and the combating of money laundering and
                    terrorism, we require the following information.
                </p>

                <form class="row" @submit.prevent="save">
                    <div class="form-group col-12">
						<label>Average Investment Amount</label>
						<div class="input-group shadow-sm">
							<a href="#change-currency" data-toggle="modal">
								<div class="input-group-prepend value">
									<span class="input-group-text">{{ form.currency|placeholder('Select currency') }}</span>
								</div>
							</a>
							<input v-model="form.average_investment_amount" type="number" step="any" class="form-control" :class="{ 'is-invalid': form.errors.has('average_investment_amount') }" placeholder="0.00" required>
						</div>
						<has-error :form="form" field="average_investment_amount" :class="'d-block'"></has-error>
					</div>
					
					<div class="col-12 border-top mt-3">
						<button-component :busy="form.busy" :label="'Save'" :label-loading="'Saving changes...'" :button-class="'btn btn-default float-right mt-3 shadow-sm'"></button-component>
					</div>
				</form>

				<change-currency-component :backdrop="false" :currency="form.currency" @change-currency="changeCurrency"></change-currency-component>
            </div>
        </div>
	</div>
</template>

<style scoped>
	select.form-control[multiple] {
		min-height: 200px;
	}

	@media (max-width: 425px) {
		select.form-control[multiple] {
			min-height: 0px;
			height: calc(1.5em + 0.9375rem + 2px);
		}
	}

	.input-group-text {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right-style: none;
	}
</style>

<script>
	export default {
		data() {
			const { external_client_id } = this.$store.getters.company;
			return {
				loading: false,
				error: null,
				options: null,
				financial_information: null,
				currency: null,
				form: new Form({
					average_investment_amount: null,
					currency: null,
					external_client_id,
				}),
			};
		},
		created() {
			this.fetchFinancialInformation();
		},
		watch: {
			$route: "fetchFinancialInformation",
			currency: function (value) {
				this.changeCurrency(value);
			},
		},
		methods: {
			changeCurrency(currency) {
				this.form.currency = currency;
			},
			fetchFinancialInformation() {
				const { external_client_id } = this.$store.getters.company;
				this.error = null;
				this.loading = true;

				axios
					.get(`/api/companies/${external_client_id}`)
					.then((response) => {
						this.financial_information =
							response.data.data.company.financial_information;

						if (!_.isEmpty(this.financial_information)) {
							const {
								average_investment_amount,
								currency,
							} = this.financial_information;

							this.form.fill({
								average_investment_amount,
								currency,
								external_client_id,
							});
						}
					})
					.catch((error) => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = this.refresh = false;
					});
			},
			save() {
				this.form
					.post("/api/financial-information")
					.catch(() => {
						this.errors = this.form.errors.get("error");
					})
					.finally(() => {
						window.scrollTo(0, 0);
					});
			},
		},
	};
</script>
